import ModalDialog from 'components/ModalDialog';
import React, { Fragment, useState } from 'react';

import StatusDetails from './StatusDetails';

interface RowData {
  age?: number | string;
  lifecycle_count: number;
}

const AgeAndStatusHistory: React.FC<{ rowData: RowData }> = ({ rowData }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <Fragment>
      <u>
        <span
          style={{ fontWeight: 'bolder', cursor: 'pointer' }}
          onClick={() => setIsModalOpen(true)}
        >
          {rowData.age === undefined ||
          rowData.age === null ||
          rowData.age.toString() === ''
            ? '...'
            : rowData.age}
        </span>
      </u>
      {rowData.lifecycle_count > 1 && <sup>*{rowData.lifecycle_count}</sup>}
      {isModalOpen && (
        <ModalDialog
          title="Vulnerability Status History"
          subTitle={rowData['name'] || ''}
          childComponent={<StatusDetails findingId={rowData['id']} />}
          onClose={() => setIsModalOpen(false)}
        />
      )}
    </Fragment>
  );
};

export default AgeAndStatusHistory;
